import { createStyles } from '@mantine/core';
import { TOP_NAVBAR_HEIGHT } from '../constants';

export const useStyles = createStyles(
	(theme, { sticky = true }: { sticky?: boolean }) => ({
		wrapper: {
			position: sticky ? 'sticky' : undefined,
			top: 0,
			width: '100%',
			height: TOP_NAVBAR_HEIGHT,
			minHeight: TOP_NAVBAR_HEIGHT,
			maxHeight: TOP_NAVBAR_HEIGHT,
			backgroundColor: theme.other.getColor('surface/app/default'),
			zIndex: sticky ? 10 : undefined,
			paddingTop: theme.spacing.sm,
			paddingBottom: theme.spacing.sm,
			paddingLeft: theme.spacing.xl,
			paddingRight: theme.spacing.xl,
			justifyContent: 'space-between',
			flexWrap: 'nowrap',
			gap: 0,

			'@media print': {
				display: 'none',
			},
		},
	})
);
